module.exports = __webpack_public_path__ + "producr-dried fresh-grass-14.jpg?800502d59919ca6c42b46fb3fbbe6de3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-14.jpg
// module id = 72
// module chunks = 0